const modelData = ({key, data}) => {
  const reg = 'dbdok'
  switch (key) {
    case 'index':
      return {
        req: JSON.stringify({
          id: data?.id,
          ep: data?._ldata,
          reg,
        }),
      }
    case 'update':
      return {
        req: JSON.stringify({
          id: data?.id,
          ep: data?._ldata,
          stgterbilang1: data?.change?.terbilang1,
          stgpromoklinik: data?.change?.promoklinik,
          stgpromostatus1: data?.change?.promostatus1,
          reg,
        }),
      }
    default:
      return null
  }
}

export {modelData}
